/**
 * TransformationDetails — Shows payment transformation metadata.
 * Reads from payment.transformationDetails in Redux.
 */
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import ColumnLayout from '@cloudscape-design/components/column-layout';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Box from '@cloudscape-design/components/box';
import Badge from '@cloudscape-design/components/badge';
import { useAppSelector } from 'src/store/hooks';
import { CopyableText } from 'src/components/common/CopyableText';
import { formatIsoTimestamp } from 'src/utils/formatters';

const KeyValue = ({ label, value }: { label: string; value: string | React.ReactNode }) => (
  <SpaceBetween size="xxs">
    <Box variant="awsui-key-label">{label}</Box>
    <Box>{value}</Box>
  </SpaceBetween>
);

export const TransformationDetails = () => {
  const payment = useAppSelector(state => state.payment.data);

  if (!payment?.transformationDetails) return null;

  const t = payment.transformationDetails;

  return (
    <Container header={<Header variant="h2">Transformation Details</Header>}>
      <ColumnLayout columns={3} variant="text-grid">
        {t.fileName && <KeyValue label="File Name" value={<CopyableText value={t.fileName} />} />}
        {t.pluginName && <KeyValue label="Plugin" value={<Badge>{t.pluginName}</Badge>} />}
        {t.batchIndex && <KeyValue label="Batch Index" value={t.batchIndex} />}
        {t.transformationTime && <KeyValue label="Transformation Time" value={formatIsoTimestamp(t.transformationTime)} />}
        {t.errorMessage && <KeyValue label="Error" value={<Box color="text-status-error">{t.errorMessage}</Box>} />}
        {t.errorCode && <KeyValue label="Error Code" value={t.errorCode} />}
      </ColumnLayout>
    </Container>
  );
};
